import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function ArrowCircleDownLeftIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M12 2.438A9.562 9.562 0 1 0 21.563 12 9.574 9.574 0 0 0 12 2.437Zm0 18A8.438 8.438 0 1 1 20.438 12 8.447 8.447 0 0 1 12 20.438Zm3.398-11.835a.563.563 0 0 1 0 .795l-5.04 5.04H13.5a.563.563 0 0 1 0 1.124H9A.562.562 0 0 1 8.437 15v-4.5a.562.562 0 1 1 1.126 0v3.142l5.04-5.04a.562.562 0 0 1 .795 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  )
}
